(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dpa-product-slider"] && !Shopify.designMode) return;
  try {
    
  function dpaInitSliders(scope) {
    (scope || document).querySelectorAll('[data-dpa-slider]').forEach(function (root) {
      if (root.dataset.dpaInit) return;
      root.dataset.dpaInit = '1';
      var track = root.querySelector('.dpa-slider__track');
      root.querySelectorAll('[data-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = track.querySelector('.dpa-slider__item');
          var step = item ? (item.getBoundingClientRect().width + 16) * 2 : 600;
          track.scrollBy({ left: btn.dataset.dir === 'next' ? step : -step, behavior: 'smooth' });
        });
      });
    });
  }
  dpaInitSliders();
  document.addEventListener('shopify:section:load', function (e) { dpaInitSliders(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpa-story-block"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    function sync(scope) {
      (scope || document).querySelectorAll('[data-dpa-story-video]').forEach(function (video) {
        if (reduce.matches) {
          video.pause();
          video.controls = true;
        } else {
          video.controls = false;
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () { video.controls = true; });
        }
      });
    }
    sync();
    reduce.addEventListener('change', function () { sync(); });
    document.addEventListener('shopify:section:load', function (e) { sync(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
